export default __webpack_public_path__ + "static/media/r5.e61c807f.jpg";